import {FC, useState} from 'react';
import {useNavigate} from 'react-router';

import ContractComponent from '@/pages/(shared)/legal/contract';

import Page from '@/components/Page';

import {useCreateOrder} from '../providers/createOrderProvider';

/**
 * Positions details component
 * @returns {JSX.Element}
 */
const OrderDetailsComponent: FC = () => {
  const navigate = useNavigate();
  const {
    setAcknowledging,
    acknowledged,
    setAcknowledged,
    handleSubmitOrder,
    validOrderProducts,
    orderItems,
    isSubmitting,
  } = useCreateOrder();

  const [isReviewing, setIsReviewing] = useState(false);

  const agreements = [
    {
      id: 'terms',
      label: 'I acknowledge and agree to the',
      link: {
        text: 'terms and conditions',
        url: '#',
      },
    },
  ];

  const handleContractAccept = () => {
    setAcknowledged(true);
    setIsReviewing(false);
  };

  const handleContractDecline = () => {
    setAcknowledged(false);
    setIsReviewing(false);
  };

  const handleSubmit = async () => {
    if (acknowledged) {
      try {
        await handleSubmitOrder();
        navigate('/admin/orders');
      } catch (error) {
        console.error('Error submitting order in component:', error);
      }
    }
  };

  return (
    <Page
      currentPage="Review Order"
      activePage="Review Order"
      mainPage="Review Order"
      handleBack={() => {
        if (isReviewing) {
          setIsReviewing(false);
        } else {
          setAcknowledging(false);
        }
      }}
    >
      {isReviewing ? (
        <ContractComponent agreements={agreements} onAccept={handleContractAccept} onDecline={handleContractDecline} />
      ) : (
        <div className="grid grid-cols-12 gap-6">
          <div className="col-span-12 w-full xl:col-span-12">
            <div className="box">
              <div className="box-header block md:flex">
                <div className="h5 mb-0 block items-center sm:flex">
                  <img className="w-10" src={'/images/logo/logo.png'} alt="" />
                  <div className="ms-0 mt-2 sm:ms-2 sm:mt-0">
                    <div className="h6 mb-0 font-semibold">ORDER REVIEW</div>
                  </div>
                </div>
              </div>
              <div className="box-body">
                <div className="grid grid-cols-12 gap-4">
                  <div className="col-span-12 xl:col-span-12">
                    <div className="table-responsive">
                      <table className="nowrap mt-4 table min-w-full whitespace-nowrap border dark:border-defaultborder/10">
                        <thead>
                          <tr>
                            <th scope="row" className="text-start">
                              Product
                            </th>
                            <th scope="row" className="text-start">
                              Brand
                            </th>
                            <th scope="row" className="text-start">
                              Product Quantity
                            </th>
                            <th scope="row" className="text-start">
                              Order Quantity
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {validOrderProducts &&
                            validOrderProducts.map((item, index) => (
                              <tr
                                key={`${item.item_count}-${index}`}
                                className="border border-defaultborder dark:border-defaultborder/10"
                              >
                                {/* MARKET */}
                                <td>
                                  <div className="font-semibold">{item.product.product_name}</div>
                                </td>
                                {/* BRAND */}
                                <td>
                                  <div className="text-[#8c9097] dark:text-white/50">{item.brand.brand_name}</div>
                                </td>
                                {/* PRODUCT */}
                                <td>
                                  <div className="text-[#8c9097] dark:text-white/50">{item.item_count}</div>
                                </td>
                                {/* QUANTITY */}
                                <td className="product-quantity-container">{orderItems[item.product.product_id]}</td>
                                {/* WHOLESALE */}
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>

              <div className="box-footer md:itsearchems-center flex flex-col items-start justify-between space-y-4 md:flex-row md:space-y-0">
                <div className="flex items-center">
                  <input
                    type="checkbox"
                    id="terms"
                    className="mr-2"
                    checked={acknowledged}
                    onChange={e => setIsReviewing(e.target.checked)}
                  />
                  <label htmlFor="terms" className="text-sm">
                    I acknowledge and agree to the terms and conditions
                  </label>
                </div>
                <div className="flex space-x-2">
                  <button onClick={() => setAcknowledging(false)} type="button" className="ti-btn bg-danger text-white">
                    Cancel <i className="ri-close-line ms-1 align-middle"></i>
                  </button>
                  <button
                    type="button"
                    className={`ti-btn ${acknowledged && !isSubmitting ? 'bg-success text-white' : 'cursor-not-allowed bg-gray-400 text-gray-600'}`}
                    disabled={!acknowledged || isSubmitting}
                    onClick={handleSubmit}
                  >
                    {isSubmitting ? 'Submitting...' : 'Submit'} <i className="ri-check-line ms-1 align-middle"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </Page>
  );
};

export default OrderDetailsComponent;
